var _rect, _rect2, _rect3, _path, _circle, _circle2, _circle3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _circle4, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 199,
    height: 164,
    fill: "none",
    viewBox: "0 0 199 164",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45.329,
    height: 16.942,
    x: 33.885,
    y: 149.013,
    fill: "#E4F4FF",
    rx: 8.471,
    transform: "rotate(-30 33.885 149.013)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 22.565,
    height: 16.924,
    x: 11.068,
    y: 103.474,
    fill: "#E4F4FF",
    rx: 8.462,
    transform: "rotate(-30 11.068 103.474)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 16.942,
    height: 16.942,
    x: 141.77,
    y: 8.471,
    fill: "#E4F4FF",
    rx: 8.471,
    transform: "rotate(-30 141.77 8.471)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E4F4FF",
    fillRule: "evenodd",
    d: "M43.094 65.442a8.471 8.471 0 008.45 14.685l26.063-15.048a8.471 8.471 0 118.47 14.673L64.986 91.93l-.003.002-7.86 4.538-7.19 4.151a8.472 8.472 0 008.47 14.673l26.43-15.259 41.762-24.111.021-.013 28.956-16.718.023-.013 7.168-4.138a8.471 8.471 0 10-8.471-14.673l-20.884 12.058a.226.226 0 01.016-.01l-1.287.743a8.472 8.472 0 01-8.471-14.672l6.249-3.608a8.471 8.471 0 00-8.501-14.656L43.094 65.442zm83.184 10.674a8.472 8.472 0 008.465 14.656 8.345 8.345 0 01-.319.194l20.874-12.051a8.472 8.472 0 018.471 14.672L100.9 129.885a8.471 8.471 0 01-8.488-14.663l-10.477 6.049-.041.024 11.41-6.588a8.471 8.471 0 00-8.43-14.696l41.061-23.707a9.15 9.15 0 01.343-.188z",
    clipRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 189.922,
    cy: 99.85,
    r: 4.15,
    stroke: "#E4F4FF",
    strokeWidth: 2.605
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.343,
    cy: 43.625,
    r: 3.022,
    stroke: "#E4F4FF",
    strokeWidth: 2.605
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.456,
    cy: 150.809,
    r: 3.022,
    stroke: "#E4F4FF",
    strokeWidth: 2.605
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 10.53,
    height: 1.88,
    x: 120.533,
    y: 4.325,
    fill: "#E4F4FF",
    rx: 0.94
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 10.53,
    height: 1.88,
    x: 126.738,
    fill: "#E4F4FF",
    rx: 0.94,
    transform: "rotate(90 126.738 0)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 7.898,
    height: 1.88,
    x: 157.014,
    y: 125.329,
    fill: "#E4F4FF",
    rx: 0.94
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 7.898,
    height: 1.88,
    x: 161.902,
    y: 122.414,
    fill: "#E4F4FF",
    rx: 0.94,
    transform: "rotate(90 161.902 122.414)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 7.898,
    height: 1.88,
    x: 7.146,
    y: 87.157,
    fill: "#E4F4FF",
    rx: 0.94
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 7.898,
    height: 1.88,
    x: 12.035,
    y: 84.242,
    fill: "#E4F4FF",
    rx: 0.94,
    transform: "rotate(90 12.035 84.242)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 99.529,
    cy: 81.812,
    r: 40.385,
    fill: "#fff",
    stroke: "#32A3F5",
    strokeWidth: 2.605
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    width: 79,
    height: 79,
    x: 60,
    y: 42,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 99.529,
    cy: 81.812,
    r: 39.082,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C7E8FF",
    d: "M99.529 39.343H142.78V123.239H99.529z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#32A3F5",
    strokeWidth: 5.732,
    d: "M82.072 84.287l10.683 10.682 24.361-24.36"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.549cd10a.svg";
export { ForwardRef as ReactComponent };